const TimeHelper = {
  nowInSeconds() {
    return Math.floor(Date.now() / 1000);
  },
};

export default TimeHelper;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/util/TimeHelper.js